
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <form [formGroup]="addressForm" (ngSubmit)="submit()">
      <div class="modal-header">
        <h4 class="modal-title">Modify Address</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col-sm-6">
            <label class="required" for="modifyAddressName1">Address Name 1</label>
            <input class="form-control" id="modifyAddressName1" type="text" formControlName="name1" name="name1">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyAddressName2">Address Name 2</label>
            <input class="form-control" id="modifyAddressName2" type="text" formControlName="name2" name="name2">
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="modifyAddressLine1">Address Line 1</label>
            <input class="form-control" id="modifyAddressLine1" type="text" formControlName="line1" name="line1">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyAddressLine2">Address Line 2</label>
            <input class="form-control" id="modifyAddressLine2" type="text" formControlName="line2" name="line2">
          </div>
          <div class="form-group col-sm-6">
            <label class="required" [for]="'modifyAddressCountry'">Country</label>
            <select-country [inputId]="'modifyAddressCountry'" formControlName="country" [inputName]="'country'" (change)="countryChanged()"></select-country>
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="modifyAddressCity">City</label>
            <input class="form-control" id="modifyAddressCity" type="text" formControlName="city" name="city">
          </div>
          <div class="form-group col-sm-6">
            <label [for]="'modifyAddressRegion'">Region</label>
            <select-region [inputId]="'modifyAddressRegion'" formControlName="region" [inputName]="'region'" [countryId]="countryId"></select-region>
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyAddressPostalCode">Postal Code</label>
            <input class="form-control" id="modifyAddressPostalCode" type="text" formControlName="postalCode" name="postalCode">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
        <button class="btn btn-primary" type="submit" [disabled]="!addressForm.valid">Save</button>
      </div>
    </form>
  </div>
</div>